var Curriculog = window.Curriculog || {};
(function ($, _, Backbone) {

	/**
	 * Action logging for UI interactions
	 *
	 * Primarily used for our Robo Reuter Clog Buster (curriculog-robot) testing framework
	 *
	 * A list of the current actions can be found here:
	 * https://gitlab.digarc.com/bhunt/curriculog-robot/wikis/List-of-UI-Actions
	 *
	 * If you make a new action, edit the above doc with the new action
	 */
	Curriculog.Actions = {
		// this is where the actions are stored
		actions: [],
		// If debug is true, every action gets printed to the console.
		debug: false,
		// Actions version number. To be incremented after each robot deploy for temporary backwards compatibility.
		// major.minor.build.revision - only use integers in each field (no letters)
		version: '1.0.0',

		// log adds a new action to the list
		log: function (action, data) {
			this.actions.push({
				created: (new Date()).getTime(),
				action: action,
				data: data
			});

			this.debug && console.trace(action);
		},

		// Search the action list for a specific action
		// Optionally, id can be passed in to limit the search to actions after that id
		has: function (action, id) {

			// id is optional. Default to zero to check all actions
			if(typeof id == 'undefined') {
				id = 0;
			}

			// In most/all cases, the action being search for will be closer to the end.
			// Search backwards
			for(i = this.actions.length - 1; i >= id; i--) {
				if(this.actions[i].action == action) {
					return true;
				}
			}

			return false;
		},

		// Get the last index, base 1. Its a useful helper from the bot side
		getLastID: function () {
			return this.actions.length;
		}
	};
})(jQuery, _, Backbone);
